import { render, staticRenderFns } from "./UploadImg.vue?vue&type=template&id=1764264a&scoped=true"
import script from "./UploadImg.vue?vue&type=script&lang=js"
export * from "./UploadImg.vue?vue&type=script&lang=js"
import style0 from "./UploadImg.vue?vue&type=style&index=0&id=1764264a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1764264a",
  null
  
)

export default component.exports